import { RouteConfig } from 'vue-router';
import DataView from '@/layout/data-manage/data-view.vue';
import middleware from '@/layout/middleware.vue';
import weather from '@/component/weather/weather/weather.vue';
import BaiduMapLocation from '@/component/weather/baidumap/baidu-map-location.vue';
const GeneralTemplate = (): Promise<typeof import('*.vue')> => import('@/component/template/general-template.vue');

import {
    iesResilienceEval,
    ieslabWeatherData,
    ieslabPhotovoltaicSys,
    ieslabWindPowerGenerator,
    ieslabGasTurbine,
    ieslabHeatPump,
    ieslabGasBoiler,
    ieslabHPSolarCollector,
    ieslabCompRefrg,
    ieslabAbsorptionChiller,
    ieslabBattery,
    ieslabWaterTank,
    ieslabIceStorageAC,
    ieslabTransformer,
    ieslabTransferLine,
    ieslabMMC,
    ieslabCentrifugalPump,
    ieslabPipe,
    ieslabThermalLoads,
    ieslabPowerLoad,
    ieslabFuel,
    ieslabHVACHeating,
    ieslabHVACCooling,
    ieslabConstPower,
    ieslabTimeSharing,
    ieslabLadderElectricity,
    ieslabLadderTime,
} from './index';

// 规划设计路由
const dataRouter: RouteConfig = {
    path: 'data',
    name: 'data',
    component: DataView,
    redirect: 'data/weather',
    meta: { requireAuth: true },
    children: [
        {
            path: 'weather',
            component: middleware,
            name: 'Weather',
            redirect: 'weather/map',
            meta: {
                title: '气象数据库',
                role: ['admin', 'editor'],
                icon: 'weather',
                disableInTypicalLib: true,
                visible: ieslabWeatherData,
            },
            children: [
                {
                    path: 'map',
                    component: BaiduMapLocation,
                    name: 'map',
                    meta: { title: '地点', role: ['admin', 'editor'], icon: 'energy', visible: ieslabWeatherData },
                },
                {
                    path: 'weather_data',
                    component: weather,
                    name: 'weather_data',
                    meta: {
                        title: '气象数据',
                        role: ['admin', 'editor'],
                        icon: 'energy',
                        visible: ieslabWeatherData,
                    },
                },
            ],
        },
        {
            path: 'disaster',
            component: middleware,
            name: 'Disaster',
            meta: { title: '灾害信息库', role: ['admin', 'editor'], icon: 'disaster', visible: iesResilienceEval },
            children: [
                {
                    path: 'typhoon',
                    component: GeneralTemplate,
                    name: 'Typhoon',
                    meta: {
                        title: '台风灾害',
                        role: ['admin', 'editor'],
                        icon: 'disaster',
                        params: { type: 'typhoon', component: 'DisasterLoadParams' },
                        visible: iesResilienceEval,
                    },
                },
                {
                    path: 'rainfall',
                    component: GeneralTemplate,
                    name: 'Rainfall',
                    meta: {
                        title: '降雨灾害',
                        role: ['admin', 'editor'],
                        icon: 'disaster',
                        params: { type: 'rainfall', component: 'DisasterLoadParams' },
                        visible: iesResilienceEval,
                    },
                },
                {
                    path: 'earthquake',
                    component: GeneralTemplate,
                    name: 'Earthquake',
                    meta: {
                        title: '地震灾害',
                        role: ['admin', 'editor'],
                        icon: 'disaster',
                        params: { type: 'earthquake', component: 'DisasterLoadParams' },
                        visible: iesResilienceEval,
                    },
                },
                {
                    path: 'extremeCold',
                    component: GeneralTemplate,
                    name: 'ExtremeCold',
                    meta: {
                        title: '极寒灾害',
                        role: ['admin', 'editor'],
                        icon: 'disaster',
                        params: { type: 'extremeCold', component: 'DisasterLoadParams' },
                        visible: iesResilienceEval,
                    },
                },
            ],
        },

        {
            path: 'eq',
            component: middleware,
            name: 'Eq',
            meta: {
                title: '设备信息库',
                role: ['admin', 'editor'],
                icon: 'equip',
                visible:
                    ieslabPhotovoltaicSys ||
                    ieslabWindPowerGenerator ||
                    ieslabGasTurbine ||
                    ieslabHeatPump ||
                    ieslabGasBoiler ||
                    ieslabHPSolarCollector ||
                    ieslabCompRefrg ||
                    ieslabAbsorptionChiller ||
                    ieslabBattery ||
                    ieslabWaterTank ||
                    ieslabIceStorageAC ||
                    ieslabTransformer ||
                    ieslabTransferLine ||
                    ieslabMMC ||
                    ieslabCentrifugalPump ||
                    ieslabPipe,
            },
            children: [
                {
                    path: 'dpc',
                    component: middleware,
                    name: 'dpc',
                    meta: {
                        title: '发电设备',
                        role: ['admin', 'editor'],
                        icon: 'energy',
                        visible: ieslabPhotovoltaicSys || ieslabWindPowerGenerator || ieslabGasTurbine,
                    },
                    children: [
                        {
                            path: 'PhotovoltaicSys',
                            component: GeneralTemplate,
                            name: 'PhotovoltaicSys',
                            meta: {
                                title: '光伏',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dpcs', params: 'PhotovoltaicSys', component: 'PhotovoltaicSys' },
                                visible: ieslabPhotovoltaicSys,
                                isShowBatchImport: true,
                            },
                        },
                        {
                            path: 'WindPowerGenerator',
                            component: GeneralTemplate,
                            name: 'WindPowerGenerator',
                            meta: {
                                title: '风机',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dpcs', params: 'WindPowerGenerator', component: 'WindPowerGenerator' },
                                visible: ieslabWindPowerGenerator,
                                isShowBatchImport: false,
                            },
                        },
                        {
                            path: 'GasTurbine',
                            component: GeneralTemplate,
                            name: 'GasTurbine',
                            meta: {
                                title: '燃气轮机',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dpcs', params: 'GasTurbine', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabGasTurbine,
                                isShowBatchImport: false,
                            },
                        },
                    ],
                },
                {
                    path: 'dhsc',
                    component: middleware,
                    name: 'dhsc',
                    meta: {
                        title: '制冷制热设备',
                        role: ['admin', 'editor'],
                        icon: 'energy',
                        visible: ieslabHeatPump || ieslabGasBoiler || ieslabHPSolarCollector || ieslabCompRefrg || ieslabAbsorptionChiller,
                    },
                    children: [
                        {
                            path: 'HeatPump',
                            component: GeneralTemplate,
                            name: 'HeatPump',
                            meta: {
                                title: '热泵',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dhscs', params: 'HeatPump', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabHeatPump,
                                isShowBatchImport: false,
                            },
                        },
                        {
                            path: 'GasBoiler',
                            component: GeneralTemplate,
                            name: 'GasBoiler',
                            meta: {
                                title: '燃气锅炉',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dhscs', params: 'GasBoiler', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabGasBoiler,
                                isShowBatchImport: false,
                            },
                        },
                        {
                            path: 'HPSolarCollector',
                            component: GeneralTemplate,
                            name: 'HPSolarCollector',
                            meta: {
                                title: '热管式太阳能集热器',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dhscs', params: 'HPSolarCollector', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabHPSolarCollector,
                                isShowBatchImport: true,
                            },
                        },
                        {
                            path: 'CompRefrg',
                            component: GeneralTemplate,
                            name: 'CompRefrg',
                            meta: {
                                title: '电压缩制冷机',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dhscs', params: 'CompRefrg', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabCompRefrg,
                                isShowBatchImport: false,
                            },
                        },
                        {
                            path: 'AbsorptionChiller',
                            component: GeneralTemplate,
                            name: 'AbsorptionChiller',
                            meta: {
                                title: '吸收式制冷机',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dhscs', params: 'AbsorptionChiller', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabAbsorptionChiller,
                                isShowBatchImport: false,
                            },
                        },
                    ],
                },
                {
                    path: 'esc',
                    component: middleware,
                    name: 'esc',
                    meta: { title: '储能设备', role: ['admin', 'editor'], icon: 'energy', visible: ieslabBattery || ieslabWaterTank || ieslabIceStorageAC },
                    children: [
                        {
                            path: 'Battery',
                            component: GeneralTemplate,
                            name: 'Battery',
                            meta: {
                                title: '蓄电池',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'escs', params: 'Battery', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabBattery,
                                isShowBatchImport: true,
                            },
                        },
                        {
                            path: 'WaterTank',
                            component: GeneralTemplate,
                            name: 'WaterTank',
                            meta: {
                                title: '储水罐',
                                role: ['admin', 'editor'],

                                icon: '',
                                params: { type: 'escs', params: 'WaterTank', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabWaterTank,
                                isShowBatchImport: true,
                            },
                        },
                        {
                            path: 'IceStorageAC',
                            component: GeneralTemplate,
                            name: 'IceStorageAC',
                            meta: {
                                title: '蓄冰空调',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'escs', params: 'IceStorageAC', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabIceStorageAC,
                                isShowBatchImport: true,
                            },
                        },
                    ],
                },
                {
                    path: 'dstc',
                    component: middleware,
                    name: 'dstc',
                    meta: {
                        title: '配电系统传输设备',
                        role: ['admin', 'editor'],
                        icon: 'energy',
                        visible: ieslabTransformer || ieslabTransferLine || ieslabMMC,
                    },
                    children: [
                        {
                            path: 'Transformer',
                            component: GeneralTemplate,
                            name: 'Transformer',
                            meta: {
                                title: '变压器',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dstcs', params: 'Transformer', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabTransformer,
                                isShowBatchImport: true,
                            },
                        },
                        {
                            path: 'TransferLine',
                            component: GeneralTemplate,
                            name: 'TransferLine',
                            meta: {
                                title: '传输线',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dstcs', params: 'TransferLine', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabTransferLine,
                                isShowBatchImport: true,
                            },
                        },
                        {
                            path: 'MMC',
                            component: GeneralTemplate,
                            name: 'MMC',
                            meta: {
                                title: '模块化多电平变流器',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dstcs', params: 'MMC', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabMMC,
                                isShowBatchImport: true,
                            },
                        },
                    ],
                },
                {
                    path: 'hstc',
                    component: middleware,
                    name: 'hstc',
                    meta: {
                        title: '供热系统传输设备',
                        role: ['admin', 'editor'],
                        icon: 'energy',
                        visible: ieslabCentrifugalPump || ieslabPipe,
                    },
                    children: [
                        {
                            path: 'CentrifugalPump',
                            component: GeneralTemplate,
                            name: 'CentrifugalPump',
                            meta: {
                                title: '离心泵',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'hstcs', params: 'CentrifugalPump', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabCentrifugalPump,
                                isShowBatchImport: false,
                            },
                        },
                        {
                            path: 'Pipe',
                            component: GeneralTemplate,
                            name: 'Pipe',
                            meta: {
                                title: '管道',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'hstcs', params: 'Pipe', component: 'EquipmentInformationDetailsCard' },
                                visible: ieslabPipe,
                                isShowBatchImport: true,
                            },
                        },
                    ],
                },
            ],
        },
        {
            path: 'load',
            component: middleware,
            name: 'Load',
            meta: { title: '负荷信息库', role: ['admin', 'editor'], icon: 'load', visible: ieslabThermalLoads || ieslabPowerLoad },
            children: [
                {
                    path: 'thermalLoads',
                    component: GeneralTemplate,
                    name: 'HeatingLoad',
                    meta: {
                        title: '采暖制冷负荷',
                        role: ['admin', 'editor'],
                        icon: 'load',
                        params: { type: 'thermalLoads', component: 'ThermalLoad' },
                        visible: ieslabThermalLoads,
                    },
                },
                {
                    path: 'powerLoad',
                    component: GeneralTemplate,
                    name: 'ElectricLoad',
                    meta: {
                        title: '电负荷',
                        role: ['admin', 'editor'],
                        icon: 'load',
                        params: { type: 'electricLoads', component: 'IesElectricalLoadParams' },
                        visible: ieslabPowerLoad,
                    },
                },
            ],
        },
        {
            path: 'energy',
            component: middleware,
            name: 'Energy',
            meta: {
                title: '能源信息库',
                role: ['admin', 'editor'],
                icon: 'energy',
                visible:
                    ieslabFuel ||
                    ieslabHVACHeating ||
                    ieslabHVACCooling ||
                    ieslabConstPower ||
                    ieslabTimeSharing ||
                    ieslabLadderElectricity ||
                    ieslabLadderTime,
            },
            children: [
                {
                    path: 'fuel',
                    component: GeneralTemplate,
                    name: 'Fuel',
                    meta: {
                        title: '燃料',
                        role: ['admin', 'editor'],
                        icon: '',
                        params: { type: 'fuels', component: 'FuelInformationDetailsCardByIes' },
                        visible: ieslabFuel,
                    },
                },
                {
                    path: 'HVACHeating',
                    component: GeneralTemplate,
                    name: 'HVACHeating',
                    meta: {
                        title: '热',
                        role: ['admin', 'editor'],
                        icon: '',
                        params: { type: 'hots', params: 'HVACHeating', component: 'HotInformationDetailsCard' },
                        visible: ieslabHVACHeating,
                    },
                },
                {
                    path: 'HVACCooling',
                    component: GeneralTemplate,
                    name: 'HVACCooling',
                    meta: {
                        title: '冷',
                        role: ['admin', 'editor'],
                        icon: '',
                        params: { type: 'colds', params: 'HVACCooling', component: 'ColdInformationDetailsCard' },
                        visible: ieslabHVACCooling,
                    },
                },
                {
                    path: 'electricity',
                    component: middleware,
                    name: 'Electricity',
                    meta: {
                        title: '电',
                        role: ['admin', 'editor'],
                        icon: 'energy',
                        type: 'elects',
                        visible: ieslabConstPower || ieslabTimeSharing || ieslabLadderElectricity || ieslabLadderTime,
                    },
                    children: [
                        {
                            path: 'constPower',
                            component: GeneralTemplate,
                            name: '常数电价',
                            meta: {
                                title: '常数电价',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'elects', params: '常数电价', component: 'ConstantPowerParamsByIes' },
                                visible: ieslabConstPower,
                            },
                        },
                        {
                            path: 'TimeSharing',
                            component: GeneralTemplate,
                            name: '分时电价',
                            meta: {
                                title: '分时电价',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'elects', params: '分时电价', component: 'TimeSharingElectricityParamsByIes' },
                                visible: ieslabTimeSharing,
                            },
                        },
                        {
                            path: 'LadderElectricity',
                            component: GeneralTemplate,
                            name: '阶梯电价',
                            meta: {
                                title: '阶梯电价',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'elects', params: '阶梯电价', component: 'LadderElectricityPriceParamsByIes' },
                                visible: ieslabLadderElectricity,
                            },
                        },
                        {
                            path: 'LadderTime',
                            component: GeneralTemplate,
                            name: '分时+阶梯',
                            meta: {
                                title: '分时阶梯电价',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'elects', params: '分时+阶梯', component: 'LadderTimeParamsByIes' },
                                visible: ieslabLadderTime,
                            },
                        },
                    ],
                },
            ],
        },
    ],
};

// 建模仿真路由
const iesDataRouter: RouteConfig = {
    path: 'data',
    name: 'ies-data',
    component: DataView,
    redirect: 'data/weather',
    meta: { requireAuth: true },
    children: [
        {
            path: 'weather',
            component: middleware,
            name: 'ies-Weather',
            redirect: 'weather/map',
            meta: {
                title: '气象数据库',
                role: ['admin', 'editor'],
                icon: 'weather',
                disableInTypicalLib: true,
                visible: ieslabWeatherData,
            },
            children: [
                {
                    path: 'map',
                    component: BaiduMapLocation,
                    name: 'ies-map',
                    meta: { title: '地点', role: ['admin', 'editor'], icon: 'energy', visible: ieslabWeatherData },
                },
                {
                    path: 'weather_data',
                    component: weather,
                    name: 'ies-weather_data',
                    meta: {
                        title: '气象数据',
                        role: ['admin', 'editor'],
                        icon: 'energy',
                        visible: ieslabWeatherData,
                    },
                },
            ],
        },

        {
            path: 'disaster',
            component: middleware,
            name: 'ies-Disaster',
            meta: { title: '灾害信息库', role: ['admin', 'editor'], icon: 'disaster', visible: iesResilienceEval },
            children: [
                {
                    path: 'typhoon',
                    component: GeneralTemplate,
                    name: 'ies-Typhoon',
                    meta: {
                        title: '台风灾害',
                        role: ['admin', 'editor'],
                        icon: 'disaster',
                        params: { type: 'typhoon', component: 'DisasterLoadParams' },
                        visible: iesResilienceEval,
                    },
                },
                {
                    path: 'rainfall',
                    component: GeneralTemplate,
                    name: 'ies-Rainfall',
                    meta: {
                        title: '降雨灾害',
                        role: ['admin', 'editor'],
                        icon: 'disaster',
                        params: { type: 'rainfall', component: 'DisasterLoadParams' },
                        visible: iesResilienceEval,
                    },
                },
                {
                    path: 'earthquake',
                    component: GeneralTemplate,
                    name: 'ies-Earthquake',
                    meta: {
                        title: '地震灾害',
                        role: ['admin', 'editor'],
                        icon: 'disaster',
                        params: { type: 'earthquake', component: 'DisasterLoadParams' },
                        visible: iesResilienceEval,
                    },
                },
                {
                    path: 'extremeCold',
                    component: GeneralTemplate,
                    name: 'ies-ExtremeCold',
                    meta: {
                        title: '极寒灾害',
                        role: ['admin', 'editor'],
                        icon: 'disaster',
                        params: { type: 'extremeCold', component: 'DisasterLoadParams' },
                        visible: iesResilienceEval,
                    },
                },
            ],
        },

        {
            path: 'eq',
            component: middleware,
            name: 'ies-Eq',
            meta: {
                title: '设备信息库',
                role: ['admin', 'editor'],
                icon: 'equip',
                visible:
                    ieslabPhotovoltaicSys ||
                    ieslabWindPowerGenerator ||
                    ieslabGasTurbine ||
                    ieslabHeatPump ||
                    ieslabGasBoiler ||
                    ieslabHPSolarCollector ||
                    ieslabCompRefrg ||
                    ieslabAbsorptionChiller ||
                    ieslabBattery ||
                    ieslabWaterTank ||
                    ieslabIceStorageAC ||
                    ieslabTransformer ||
                    ieslabTransferLine ||
                    ieslabMMC ||
                    ieslabCentrifugalPump ||
                    ieslabPipe,
            },
            children: [
                {
                    path: 'dpc',
                    component: middleware,
                    name: 'ies-dpc',
                    meta: {
                        title: '发电设备',
                        role: ['admin', 'editor'],
                        icon: 'energy',
                        visible: ieslabPhotovoltaicSys || ieslabWindPowerGenerator || ieslabGasTurbine,
                    },
                    children: [
                        {
                            path: 'PhotovoltaicSys',
                            component: GeneralTemplate,
                            name: 'ies-PhotovoltaicSys',
                            meta: {
                                title: '光伏',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dpcs', params: 'PhotovoltaicSys', component: 'PhotovoltaicSys' },
                                visible: ieslabPhotovoltaicSys,
                                isShowBatchImport: true,
                            },
                        },
                        {
                            path: 'WindPowerGenerator',
                            component: GeneralTemplate,
                            name: 'ies-WindPowerGenerator',
                            meta: {
                                title: '风机',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dpcs', params: 'WindPowerGenerator', component: 'WindPowerGenerator' },
                                visible: ieslabWindPowerGenerator,
                                isShowBatchImport: false,
                            },
                        },
                        {
                            path: 'GasTurbine',
                            component: GeneralTemplate,
                            name: 'ies-GasTurbine',
                            meta: {
                                title: '燃气轮机',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dpcs', params: 'GasTurbine', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabGasTurbine,
                                isShowBatchImport: false,
                            },
                        },
                    ],
                },
                {
                    path: 'dhsc',
                    component: middleware,
                    name: 'ies-dhsc',
                    meta: {
                        title: '制冷制热设备',
                        role: ['admin', 'editor'],
                        icon: 'energy',
                        visible: ieslabHeatPump || ieslabGasBoiler || ieslabHPSolarCollector || ieslabCompRefrg || ieslabAbsorptionChiller,
                    },
                    children: [
                        {
                            path: 'HeatPump',
                            component: GeneralTemplate,
                            name: 'ies-HeatPump',
                            meta: {
                                title: '热泵',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dhscs', params: 'HeatPump', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabHeatPump,
                                isShowBatchImport: false,
                            },
                        },
                        {
                            path: 'GasBoiler',
                            component: GeneralTemplate,
                            name: 'ies-GasBoiler',
                            meta: {
                                title: '燃气锅炉',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dhscs', params: 'GasBoiler', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabGasBoiler,
                                isShowBatchImport: false,
                            },
                        },
                        {
                            path: 'HPSolarCollector',
                            component: GeneralTemplate,
                            name: 'ies-HPSolarCollector',
                            meta: {
                                title: '热管式太阳能集热器',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dhscs', params: 'HPSolarCollector', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabHPSolarCollector,
                                isShowBatchImport: true,
                            },
                        },
                        {
                            path: 'CompRefrg',
                            component: GeneralTemplate,
                            name: 'ies-CompRefrg',
                            meta: {
                                title: '电压缩制冷机',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dhscs', params: 'CompRefrg', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabCompRefrg,
                                isShowBatchImport: false,
                            },
                        },
                        {
                            path: 'AbsorptionChiller',
                            component: GeneralTemplate,
                            name: 'ies-AbsorptionChiller',
                            meta: {
                                title: '吸收式制冷机',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dhscs', params: 'AbsorptionChiller', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabAbsorptionChiller,
                                isShowBatchImport: false,
                            },
                        },
                    ],
                },
                {
                    path: 'esc',
                    component: middleware,
                    name: 'ies-esc',
                    meta: { title: '储能设备', role: ['admin', 'editor'], icon: 'energy', visible: ieslabBattery || ieslabWaterTank || ieslabIceStorageAC },
                    children: [
                        {
                            path: 'Battery',
                            component: GeneralTemplate,
                            name: 'ies-Battery',
                            meta: {
                                title: '蓄电池',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'escs', params: 'Battery', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabBattery,
                                isShowBatchImport: true,
                            },
                        },
                        {
                            path: 'WaterTank',
                            component: GeneralTemplate,
                            name: 'ies-WaterTank',
                            meta: {
                                title: '储水罐',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'escs', params: 'WaterTank', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabWaterTank,
                                isShowBatchImport: true,
                            },
                        },
                        {
                            path: 'IceStorageAC',
                            component: GeneralTemplate,
                            name: 'ies-IceStorageAC',
                            meta: {
                                title: '蓄冰空调',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'escs', params: 'IceStorageAC', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabIceStorageAC,
                                isShowBatchImport: true,
                            },
                        },
                    ],
                },
                {
                    path: 'dstc',
                    component: middleware,
                    name: 'ies-dstc',
                    meta: {
                        title: '配电系统传输设备',
                        role: ['admin', 'editor'],
                        icon: 'energy',
                        visible: ieslabTransformer || ieslabTransferLine || ieslabMMC,
                    },
                    children: [
                        {
                            path: 'Transformer',
                            component: GeneralTemplate,
                            name: 'ies-Transformer',
                            meta: {
                                title: '变压器',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dstcs', params: 'Transformer', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabTransformer,
                                isShowBatchImport: true,
                            },
                        },
                        {
                            path: 'TransferLine',
                            component: GeneralTemplate,
                            name: 'ies-TransferLine',
                            meta: {
                                title: '传输线',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dstcs', params: 'TransferLine', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabTransferLine,
                                isShowBatchImport: true,
                            },
                        },
                        {
                            path: 'MMC',
                            component: GeneralTemplate,
                            name: 'ies-MMC',
                            meta: {
                                title: '模块化多电平变流器',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'dstcs', params: 'MMC', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabMMC,
                                isShowBatchImport: true,
                            },
                        },
                    ],
                },
                {
                    path: 'hstc',
                    component: middleware,
                    name: 'ies-hstc',
                    meta: {
                        title: '供热系统传输设备',
                        role: ['admin', 'editor'],
                        icon: 'energy',
                        visible: ieslabCentrifugalPump || ieslabPipe,
                    },
                    children: [
                        {
                            path: 'CentrifugalPump',
                            component: GeneralTemplate,
                            name: 'ies-CentrifugalPump',
                            meta: {
                                title: '离心泵',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'hstcs', params: 'CentrifugalPump', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabCentrifugalPump,
                                isShowBatchImport: false,
                            },
                        },
                        {
                            path: 'Pipe',
                            component: GeneralTemplate,
                            name: 'ies-Pipe',
                            meta: {
                                title: '管道',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'hstcs', params: 'Pipe', component: 'EquipmentInformationDetailsCardWithTable' },
                                visible: ieslabPipe,
                                isShowBatchImport: true,
                            },
                        },
                    ],
                },
            ],
        },
        {
            path: 'load',
            component: middleware,
            name: 'ies-Load',
            meta: { title: '负荷信息库', role: ['admin', 'editor'], icon: 'load', visible: ieslabThermalLoads || ieslabPowerLoad },
            children: [
                {
                    path: 'thermalLoads',
                    component: GeneralTemplate,
                    name: 'ies-HeatingLoad',
                    meta: {
                        title: '采暖制冷负荷',
                        role: ['admin', 'editor'],
                        icon: 'load',
                        params: { type: 'thermalLoads', component: 'ThermalLoad' },
                        visible: ieslabThermalLoads,
                    },
                },
                {
                    path: 'powerLoad',
                    component: GeneralTemplate,
                    name: 'ies-ElectricLoad',
                    meta: {
                        title: '电负荷',
                        role: ['admin', 'editor'],
                        icon: 'load',
                        params: { type: 'electricLoads', component: 'IesElectricalLoadParams' },
                        visible: ieslabPowerLoad,
                    },
                },
            ],
        },
        {
            path: 'energy',
            component: middleware,
            name: 'ies-Energy',
            meta: {
                title: '能源信息库',
                role: ['admin', 'editor'],
                icon: 'energy',
                visible:
                    ieslabFuel ||
                    ieslabHVACHeating ||
                    ieslabHVACCooling ||
                    ieslabConstPower ||
                    ieslabTimeSharing ||
                    ieslabLadderElectricity ||
                    ieslabLadderTime,
            },
            children: [
                {
                    path: 'fuel',
                    component: GeneralTemplate,
                    name: 'ies-Fuel',
                    meta: {
                        title: '燃料',
                        role: ['admin', 'editor'],
                        icon: '',
                        params: { type: 'fuels', component: 'FuelInformationDetailsCardByIes' },
                        visible: ieslabFuel,
                    },
                },
                {
                    path: 'HVACHeating',
                    component: GeneralTemplate,
                    name: 'ies-HVACHeating',
                    meta: {
                        title: '热',
                        role: ['admin', 'editor'],
                        icon: '',
                        params: { type: 'hots', params: 'HVACHeating', component: 'HotInformationDetailsCard' },
                        visible: ieslabHVACHeating,
                    },
                },
                {
                    path: 'HVACCooling',
                    component: GeneralTemplate,
                    name: 'ies-HVACCooling',
                    meta: {
                        title: '冷',
                        role: ['admin', 'editor'],
                        icon: '',
                        params: { type: 'colds', params: 'HVACCooling', component: 'ColdInformationDetailsCard' },
                        visible: ieslabHVACCooling,
                    },
                },
                {
                    path: 'electricity',
                    component: middleware,
                    name: 'ies-Electricity',
                    meta: {
                        title: '电',
                        role: ['admin', 'editor'],
                        icon: 'energy',
                        type: 'elects',
                        visible: ieslabConstPower || ieslabTimeSharing || ieslabLadderElectricity || ieslabLadderTime,
                    },
                    children: [
                        {
                            path: 'constPower',
                            component: GeneralTemplate,
                            name: 'ies-常数电价',
                            meta: {
                                title: '常数电价',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'elects', params: '常数电价', component: 'ConstantPowerParamsByIes' },
                                visible: ieslabConstPower,
                            },
                        },
                        {
                            path: 'TimeSharing',
                            component: GeneralTemplate,
                            name: 'ies-分时电价',
                            meta: {
                                title: '分时电价',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'elects', params: '分时电价', component: 'TimeSharingElectricityParamsByIes' },
                                visible: ieslabTimeSharing,
                            },
                        },
                        {
                            path: 'LadderElectricity',
                            component: GeneralTemplate,
                            name: 'ies-阶梯电价',
                            meta: {
                                title: '阶梯电价',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'elects', params: '阶梯电价', component: 'LadderElectricityPriceParamsByIes' },
                                visible: ieslabLadderElectricity,
                            },
                        },
                        {
                            path: 'LadderTime',
                            component: GeneralTemplate,
                            name: 'ies-分时+阶梯',
                            meta: {
                                title: '分时阶梯电价',
                                role: ['admin', 'editor'],
                                icon: '',
                                params: { type: 'elects', params: '分时+阶梯', component: 'LadderTimeParamsByIes' },
                                visible: ieslabLadderTime,
                            },
                        },
                    ],
                },
            ],
        },
    ],
};

export default dataRouter;
export { iesDataRouter };
